import React from 'react';
import PhoneLoginModal from './PhoneLoginModal';
import OTPVerificationModal from './OTPVerificationModal';
import WhatsAppConnectionModal from './WhatsAppConnectionModal';
import ProfileCompletionModal from './ProfileCompletionModal';

const AuthModal = ({
  isOpen,
  onClose,
  authStep,
  setAuthStep,
  loginMethod,
  setLoginMethod,
  mobile,
  setMobile,
  whatsAppNumber,
  setWhatsAppNumber,
  sendOTP,
  sendOTPForLogin,
  otp,
  appSettings,
  handleOtpChange,
  handleOtpKeyDown,
  handleFullOtpChange,
  otpMethod,
  timer,
  canResend,
  resendOTP,
  verifyOTP,
  password,
  checkPasswordStrength,
  passwordStrength,
  showPassword,
  setShowPassword,
  handleEmailLogin,
  rememberMe,
  setRememberMe,
  handleSocialLogin,
  biometricEnabled,
  handleBiometricLogin,
  connectWhatsApp,
  skipWhatsApp,
  userProfile,
  setUserProfile,
  handleProfilePicUpload,
  setShowTwoFactorSetup,
  twoFactorEnabled,
  biometricAvailable,
  enableBiometric,
  handleProfileSubmit,
  showForgotPassword,
  showSignUp,
  onShowAbout,
  error,
  setError,
  mobileNotFound,
  setMobileNotFound
}) => {

  if (!isOpen) {
    return null;
  }

  // Phone Login Screen
  if (authStep === 'phone') {
    return (
      <PhoneLoginModal
        onClose={onClose}
        mobile={mobile}
        setMobile={setMobile}
        password={password}
        checkPasswordStrength={checkPasswordStrength}
        passwordStrength={passwordStrength}
        showPassword={showPassword}
        setShowPassword={setShowPassword}
        sendOTPForLogin={sendOTPForLogin}
        sendOTP={sendOTP}
        loginMethod={loginMethod}
        setLoginMethod={setLoginMethod}
        handleEmailLogin={handleEmailLogin}
        rememberMe={rememberMe}
        setRememberMe={setRememberMe}
        handleSocialLogin={handleSocialLogin}
        biometricEnabled={biometricEnabled}
        handleBiometricLogin={handleBiometricLogin}
        showForgotPassword={showForgotPassword}
        showSignUp={showSignUp}
        onShowAbout={onShowAbout}
        error={error}
        setError={setError}
        mobileNotFound={mobileNotFound}
        setMobileNotFound={setMobileNotFound}
        appSettings={appSettings}
      />
    );
  }

  // OTP Verification Screen
  if (authStep === 'otp') {
    return (
      <OTPVerificationModal
        mobile={mobile}
        otp={otp}
        handleOtpChange={handleOtpChange}
        handleOtpKeyDown={handleOtpKeyDown}
        handleFullOtpChange={handleFullOtpChange}
        otpMethod={otpMethod}
        timer={timer}
        canResend={canResend}
        resendOTP={resendOTP}
        verifyOTP={verifyOTP}
        setAuthStep={setAuthStep}
        userProfile={userProfile} 
        setUserProfile={setUserProfile}
        error={error}
      />
    );
  }

  // WhatsApp Connection Screen
  if (authStep === 'whatsapp') {
    return (
      <WhatsAppConnectionModal
        userProfile={userProfile}
        setUserProfile={setUserProfile}
        mobile={mobile}
        whatsAppNumber={whatsAppNumber}
        setWhatsAppNumber={setWhatsAppNumber}
        connectWhatsApp={connectWhatsApp}
        skipWhatsApp={skipWhatsApp}
      />    
    );
  }

  // Profile Completion Screen
  if (authStep === 'profile') {
    return (
      <ProfileCompletionModal
        userProfile={userProfile}
        setUserProfile={setUserProfile}
        handleProfilePicUpload={handleProfilePicUpload}
        setShowTwoFactorSetup={setShowTwoFactorSetup}
        twoFactorEnabled={twoFactorEnabled}
        biometricAvailable={biometricAvailable}
        biometricEnabled={biometricEnabled}
        enableBiometric={enableBiometric}
        handleProfileSubmit={handleProfileSubmit}
        verifiedMobile={mobile}
      />
    );
  }

  return null;
};

export default AuthModal;